import { filter } from 'rxjs';
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormBuilder } from '@angular/forms';
import {
  NgbModal,
  NgbTooltipModule,
  NgbPaginationModule,
} from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { apiEndPoints } from '../../../api/apiEndPoint';
import { error } from 'console';
import { NgxSpinner, NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { MasterInformationService } from '../../../Services/master-information.service';
import { HttpResponse } from '@angular/common/http';
import { UserManagementService } from '../../../Services/user-management.service';
import { DashboardService } from '../../../Services/dashboard.service';
import * as XLSX from 'xlsx';
import autoTable from 'jspdf-autotable';
import jsPDF from 'jspdf';

@Component({
  selector: 'app-dumpyard',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbTooltipModule,
    NgbPaginationModule,
    NgxSpinnerModule,
  ],
  templateUrl: './dumpyard.component.html',
  styleUrl: './dumpyard.component.css',
})
export class DumpyardComponent {
  // Define filter options
  cities = ['New York', 'Los Angeles', 'Chicago', 'Chennai'];
  zones = ['North', 'South', 'East', 'West'];

  // ---------------------- Pagination ---------------------- //
  page = 1;
  pageSize = 5;

  // Initial user data

  // Clone users for filtering
  cityOptions: string[] = [];
  zoneOptions: string[] = [];
  userStatusOptions: string[] = [];
  statusOptions: string[] = [];
  filters: { [key: string]: string } = {}; // Stores active filters

  // Filter selection values
  selectedUserType = 'all';
  selectedCity = 'all';
  selectedZone = 'all';
  selectedStatus = 'all'; // New filter for Status
  selectedFilterStatus = ''; // Status filter (empty means all)

  // // Sort direction state
  // sortDirection: { [key: string]: 'asc' | 'desc' } = {
  //   name: 'asc',
  //   type: 'asc',
  //   date: 'asc',
  //   status: 'asc',
  //   id: 'asc', // Sorting for Requestor ID
  //   city: 'asc', // Sorting for City
  //   zone: 'asc', // Sorting for Zone
  // };

  // Modal visibility and form

  isChangeStatusPopupOpen = false;
  currentCityForStatusChange: any = null;

  userIdForDownload: any;
  downloadDocumentsModalRef: any;
  selectedZoneId: any;
  selectedCityId: any;
  cityList: any;
  zoneList: any;
  filteredData: any;
  dumpyardData: any[] = [];

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private userService: UserManagementService,
    private toastr: ToastrService,
    private masterService: MasterInformationService,
    private spinner: NgxSpinnerService,
    private dashService: DashboardService
  ) {}

  ngOnInit() {
    this.getDumpyardList();
    this.getCity();
    this.filteredData = [...this.dumpyardData];
  }

  // ------------------------------- Export to Excel ------------------------------- //
  exportToExcel(): void {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.dumpyardData);
    const wb: XLSX.WorkBook = { Sheets: { data: ws }, SheetNames: ['data'] };
    XLSX.writeFile(wb, 'DumpyardList.xlsx');
  }

  // --------------------------------------- Filter Grid --------------------------------------- //

  filterGrid() {
    if (!this.dumpyardData || !Array.isArray(this.dumpyardData)) {
      this.filteredData = [];
      return;
    }

    this.filteredData = this.dumpyardData.filter((user) => {
      const cityMatch =
        this.selectedCity === 'all' || user.cityId === +this.selectedCity; // Compare cityId directly

      const zoneMatch =
        this.selectedZone === 'all' || user.zoneId === +this.selectedZone; // Compare zoneId directly

      const statusMatch =
        this.selectedStatus === 'all' ||
        (this.selectedStatus === 'Active' && user.isActive === true) ||
        (this.selectedStatus === 'Inactive' && user.isActive === false);

      return cityMatch && zoneMatch && statusMatch;
    });
  }

  filteredUsers: any;
  // Filter function to filter users based on selected filters

  // sortGrid(column: | 'id' | 'city' | 'zone' | 'name') {
  //   const direction = this.sortDirection[column];

  //   // Sort based on current direction
  //   this.filteredUsers.sort((a, b) => {
  //     if (a[column] > b[column]) {
  //       return direction === 'asc' ? 1 : -1;
  //     } else if (a[column] < b[column]) {
  //       return direction === 'asc' ? -1 : 1;
  //     }
  //     return 0;
  //   });

  //   // Toggle the sorting direction for the next sort
  //   this.sortDirection[column] = direction === 'asc' ? 'desc' : 'asc';
  // }

  userId: any;
  isActive: any;
  // Open status change popup
  openChangeStatusPopup(content: any, user: any): void {
    this.userId = user.userId;
    this.isActive = user.isActive;
    this.currentCityForStatusChange = user;
    this.modalService.open(content, { centered: true, backdrop: 'static' });
  }
  // Change the status of the city
  changeCityStatus(model: any): void {
    const toggledStatus =
      this.isActive === true || this.isActive === 'true' ? false : true;

    this.userService
      .postActiveInactiveUser(
        apiEndPoints.UserAccountStatusUpdate,
        this.userId,
        toggledStatus
      )
      .subscribe({
        next: (response: any) => {
          model.close();
          this.currentCityForStatusChange.isActive = toggledStatus;
          this.toastr.success(
            `UserName "${
              this.currentCityForStatusChange.companyName
            }"Status Changed to ${
              this.currentCityForStatusChange.isActive ? 'Active' : 'Inactive'
            }`,
            'Status Updated',
            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            }
          );
          this.getDumpyardList();
        },
        error: (error: any) => {
          this.toastr.error(
            'An unexpected error occurred. Please try again later.',
            'Error',
            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            }
          );
        },
      });
  }

  // Handle filter selection for status
  toggleStatusFilter(status: string): void {
    // this.selectedStatus = status; // Update selected status filter
    // this.filterGrid();  // Reapply the filter with the updated status
  }

  // --------------------------------------- Apply filter for columns --------------------------------------- //

  applyFilter(key: string, value: string) {
    this.filters[key] = value; // Set filter value
    this.filteredUsers = this.dumpyardData.filter((user: any) => {
      return Object.keys(this.filters).every((filterKey) => {
        return (
          !this.filters[filterKey] ||
          user[filterKey] === this.filters[filterKey]
        );
      });
    });
  }

  // --------------------------------------- Clear filter --------------------------------------- //

  clearFilter() {
    this.getDumpyardList();
  }

  cardData: any;
  originalTableData: any;

  getDumpyardList() {
    this.userService.getUserList(apiEndPoints.allUsers, 4).subscribe({
      next: (response: any) => {
        this.dumpyardData = response.body.details.userList;
        console.log(this.dumpyardData);
        this.cardData = response.body.details;
        this.filteredData = [...this.dumpyardData];
      },
      error: (error) => {
        this.toastr.error(
          'An Unexcepted error occured.Please try again later',
          'Error',
          {
            timeOut: 3000,
            positionClass: 'toast-top-right',
            progressBar: true,
          }
        );
      },
    });
  }

  getStatus(status: any): string {
    switch (status) {
      case true:
      case 'true':
      case 1:
        return 'Active';
      case false:
      case 'false':
      case 0:
        return 'Inactive';
      default:
        return 'Unknown'; // Handle cases where the status is unexpected
    }
  }

  isFilterVisible = false;
  toggleFilterDropdown() {
    this.isFilterVisible = !this.isFilterVisible;
  }

  filter(name: any): void {
    if (name) {
      this.dumpyardData = this.originalTableData.filter((user: any) => {
        user.cityName.toLowerCase().includes(name.toLowercase()) ||
          user.zoneName.toLowerCase().includes(name.toLowercase());
      });
    } else {
      this.dumpyardData = [...this.originalTableData];
    }
    this.isFilterVisible = false;
  }

  // ----------------------------- Pagination ----------------------------- //
  get pagedData() {
    const start = (this.page - 1) * this.pageSize;
    const end = this.page * this.pageSize;
    return this.filteredData?.slice(start, end);
  }

  onPageChange(page: number): void {
    this.page = page;
  }

  // ----------------------------------- Get All City List API ----------------------------------- //

  getCity() {
    this.masterService.getCityList(apiEndPoints.cityList).subscribe({
      next: (response: any) => {
        this.cityList = response.body.details;
      },
      error: (error) => {
        this.toastr.error(
          'An unexpected error occurred. Please try again later.',
          'Error',
          {
            timeOut: 3000,
            positionClass: 'toast-top-right',
            progressBar: true,
          }
        );
      },
    });
  }

  // ----------------------------------- City Change Dropdown ----------------------------------- //

  onCityChange(event: Event) {
    const selectedCity = (event.target as HTMLSelectElement).value;
    this.selectedCity = selectedCity;

    if (this.selectedCity !== 'all') {
      this.getZone(this.selectedCity); // Call API to fetch zones for the selected city
    } else {
      this.zoneList = []; // Clear the zone list if "All" is selected
      this.selectedZone = 'all'; // Reset the zone filter
    }

    this.filterGrid(); // Filter the table based on the updated city selection
  }

  // ----------------------------------- Get All Zone List API ----------------------------------- //

  getZone(cityId: string) {
    this.dashService.getZoneList(apiEndPoints.zoneList, cityId).subscribe({
      next: (response: any) => {
        this.zoneList = response.body.details || [];
        this.selectedZone = 'all'; // Reset zone selection
      },
      error: (error) => {
        this.toastr.error(
          'An unexpected error occurred while fetching zones. Please try again later.',
          'Error',
          {
            timeOut: 3000,
            positionClass: 'toast-top-right',
            progressBar: true,
          }
        );
      },
    });
  }

  // ----------------------------------- Zone Change Dropdown ----------------------------------- //

  onZoneChange(event: Event) {
    const selectedZoneId = (event.target as HTMLSelectElement).value;
    this.selectedZoneId = selectedZoneId;
  }

  openDownloadDocumentsModal(userId: any, modal: any) {
    // this.orderIdForDownloadInvoice = orderId;
    this.userIdForDownload = userId;
    this.downloadDocumentsModalRef = this.modalService.open(modal);
  }

  downloadCrVatDocument(type: string) {
    this.downloadDocumentsModalRef.close();
    this.spinner.show();

    this.userService
      .crVatDownload(apiEndPoints.crVatDownload, this.userIdForDownload, type)
      .subscribe({
        next: (response: HttpResponse<Blob>) => {
          this.spinner.hide();

          // Extract the filename from Content-Disposition header
          const contentDisposition = response.headers.get(
            'Content-Disposition'
          );
          let filename = this.extractFileName(contentDisposition);

          // Determine file extension based on 'type' or Content-Type
          const contentType = response.headers.get('Content-Type') || '';
          let extension = this.getFileExtension(contentType, type);

          // Fallback if filename is not found
          if (!filename) {
            filename = `user-${
              this.userIdForDownload
            }-${type.toLowerCase()}.${extension}`;
          }

          // Create a Blob URL
          const blob: Blob = response.body as Blob;
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');

          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);

          this.toastr.success('File downloaded successfully', 'Success', {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });
        },
        error: (error: any) => {
          this.spinner.hide();
          console.error('Error:', error);
          this.toastr.error(
            'Unexpected error occurred. Please try again later.',
            'Error',
            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
            }
          );
        },
      });
  }

  private extractFileName(contentDisposition: string | null): string | null {
    if (!contentDisposition) return null;

    // Match filename from Content-Disposition header
    const matches = contentDisposition.match(
      /filename\*?=(?:UTF-8'')?["']?([^;"']+)/
    );
    return matches ? decodeURIComponent(matches[1]) : null;
  }

  private getFileExtension(contentType: string, type: string): string {
    const mimeMap: { [key: string]: string } = {
      'application/pdf': 'pdf',
      'image/png': 'png',
      'image/jpeg': 'jpg',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        'xlsx',
      'application/octet-stream': type.toLowerCase() === 'cr' ? 'pdf' : 'jpg', // Fallback for CR or VAT type
    };

    // If contentType is not specified, rely on 'type' (CR or VAT)
    return mimeMap[contentType] || mimeMap['application/octet-stream'];
  }

  // ------------------------------- Print List or Download PDF ------------------------------- //

  exportToPDF() {
    const doc = new jsPDF('landscape');
    const pageWidth = doc.internal.pageSize.width;
    const pdfFileName = 'Dumpyard_List.pdf';

    const logo = new Image();
    logo.src = 'assets/Images/CDM-01.png';
    logo.onload = () => {
      const logoWidth = 28;
      const logoHeight = 20;
      const logoX = (pageWidth - logoWidth) / 2;
      const logoY = 10;
      doc.addImage(logo, 'PNG', logoX, logoY, logoWidth, logoHeight);

      const arabicAddressImg = new Image();
      arabicAddressImg.src = 'assets/Images/arabic address.jpeg';
      arabicAddressImg.onload = () => {
        const arabicImgWidth = 70;
        const arabicImgHeight = 20;
        const arabicImgX = pageWidth - arabicImgWidth - 10;
        const arabicImgY = 10;
        doc.addImage(
          arabicAddressImg,
          'JPEG',
          arabicImgX,
          arabicImgY,
          arabicImgWidth,
          arabicImgHeight
        );

        // Add website below Arabic address image
        doc.setFontSize(10);
        doc.setTextColor(0, 0, 255);
        doc.text(
          'www.smart­sort.net',
          arabicImgX + arabicImgWidth / 2,
          arabicImgY + arabicImgHeight + 5,
          { align: 'left' }
        );

        const englishAddressImg = new Image();
        englishAddressImg.src = 'assets/Images/english address.jpeg';
        englishAddressImg.onload = () => {
          const englishImgWidth = 70;
          const englishImgHeight = 20;
          const englishImgX = 10;
          const englishImgY = 10;
          doc.addImage(
            englishAddressImg,
            'JPEG',
            englishImgX,
            englishImgY,
            englishImgWidth,
            englishImgHeight
          );

          // Add website below English address image
          doc.setFontSize(10);
          doc.setTextColor(0, 0, 255);
          doc.text(
            'www.smart­sort.net',
            englishImgX + englishImgWidth / 11,
            englishImgY + englishImgHeight + 5,
            { align: 'left' }
          );

          // Reset text color to black (optional, in case you add more text later)
          doc.setTextColor(0, 0, 0);

          doc.setFont('helvetica', 'bold');
          doc.setFontSize(14);
          const title = 'Dumpyard List';
          const titleY = logoY + logoHeight + 10;
          doc.text(title, pageWidth / 2, titleY, { align: 'center' });

          // Table headers
          const headers = [
            [
              { content: 'Dumpyard Name' },
              { content: 'Mobile No' },
              { content: 'City' },
              { content: 'Zone' },
              { content: 'Date Registered' },
              { content: 'CR Number' },
              { content: 'VAT Number' },
              { content: 'Status' },
            ],
          ];

          let tableBody: any[] = [];
          // Ensure Year is filled for every row
          this.pagedData.forEach((user: any) => {
            const formattedDate = new Date(user.createdDate).toLocaleDateString(
              'en-GB',
              {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
              }
            );
            let userStatus = this.getStatus(user.isActive);

            tableBody.push([
              user.companyName,
              user.phNo,
              user.cityName,
              user.zoneName,
              formattedDate,
              user.crNumber,
              user.vatNumber,
              userStatus,
            ]);
          });

          // Generate table
          autoTable(doc, {
            startY: titleY + 10,
            head: headers,
            body: tableBody,
            styles: {
              fontSize: 8,
              cellPadding: 2,
              lineWidth: 0.3,
              lineColor: [50, 50, 50],
              halign: 'center',
            },
            theme: 'grid',
            headStyles: {
              fillColor: [176, 220, 101],
              textColor: [0, 0, 0],
              fontStyle: 'bold',
              lineColor: [50, 50, 50],
              lineWidth: 0.3,
            },
            alternateRowStyles: { fillColor: [245, 245, 245] },
            columnStyles: { 0: { halign: 'center', fontStyle: 'bold' } },
            margin: { top: titleY + 20 },
            pageBreak: 'auto',
            rowPageBreak: 'avoid',
            didDrawPage: function (data) {
              const pageCount = doc.getNumberOfPages();
              doc.setFontSize(10);
              doc.text(
                `Page ${pageCount}`,
                pageWidth - 20,
                doc.internal.pageSize.height - 10
              );
            },
          });

          // Save the PDF
          doc.save(pdfFileName);
        };
      };
    };
  }
}
